const mode = 'prod';
export {mode}